import { HttpGet, HttpPost, HttpPut, HttpDelete } from "./Http"


export const getAsociaciones = async () => {
    try {
        const data = await HttpGet(`admin/asociaciones`, false)
        return data;
    } catch (error) {
        return error
    }
}


export const storeAsociacion = async (payload, editId = null) => {
    try {
        let data;
        if (editId) {
            data = await HttpPut(`admin/asociaciones/${editId}`, JSON.stringify(payload), true)
        } else {
            data = await HttpPost('admin/asociaciones', JSON.stringify(payload), true)
        }
        return data;
    } catch (error) {
        return error
    }
}

export const getAsociacion = async (id) => {
    try {
        const data = await HttpGet(`admin/asociaciones/${id}`, false)
        // console.log(data)
        return data;
    } catch (error) {
        return error
    }
}

export const deleteAsociacion = async (id) => {
    try {
        const data = await HttpDelete(`admin/asociaciones/${id}`, false)
        // console.log(data)
        return data;
    } catch (error) {
        return error
    }
}

export const asignarAsociacion = async (payload) => {
    try {
        let data;
        data = await HttpPost('admin/asociaciones/asignar', JSON.stringify(payload), true)

        return data;
    } catch (error) {
        return error
    }
}
